import { render } from "./GamesReword.vue?vue&type=template&id=695a8b90&scoped=true"
import script from "./GamesReword.vue?vue&type=script&lang=js"
export * from "./GamesReword.vue?vue&type=script&lang=js"

import "./GamesReword.vue?vue&type=style&index=0&id=695a8b90&scoped=true&lang=css"

import exportComponent from "C:\\Users\\acer1\\Desktop\\TTT-Member\\Partner\\GOODLUCK711\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695a8b90"]])

export default __exports__